import useViewer from "hooks/useViewer";

export function useBrand() {
    const viewer = useViewer();
    return viewer.brand;
}
